import Request from './request';
import { Toast } from '@polyv/polyv-ui';

import store from '@/store';
import router from '@/router';
export const groupRequest = new Request({
  // API 域名由构建注入（见 vue.config.js），未注入时兜底生产域名
  baseUrl: API_BASE || '//group-api.polyv.net',
  beforeRequest: (config) => {
    const xAuthToken = store.state.common.xAuthToken;
    if (xAuthToken) {
      config.headers['x-auth-token'] = xAuthToken;
    }
    return config;
  },
  // beforeRequestError: (error) => {
  //   // console.log('error :>> ', error);
  // },
  afterRequest: (res) => {
    const status = res.status;
    if (status !== 200) {
      Toast.error('网络请求失败');
      return Promise.reject(new Error('网络请求失败'));
    }
    const resData = res.data;
    const { code, status: resStatus } = resData;
    if (resStatus === 'success' || code === 200 || code === 0) {
      return resData.data;
    } else {
      const { error: { desc, code } } = resData;
      Toast.error(desc);
      if (code === 401) {
        router.push('/');
      }
      return Promise.reject(new Error(desc));
    }
  },
  afterRequestError: () => {
    Toast.error('网络请求失败');
  }
});
